import { render } from "./MbDiv.vue?vue&type=template&id=feffecc4"
import script from "./MbDiv.vue?vue&type=script&lang=js"
export * from "./MbDiv.vue?vue&type=script&lang=js"

import "./MbDiv.vue?vue&type=style&index=0&id=feffecc4&lang=css"

import exportComponent from "D:\\도연희\\vuestudy\\vue-noelo\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__